import React, { useEffect, useState, useCallback } from 'react';
import {
  Button,
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  styled
} from '@mui/material';
import { dateFormatter, getReccurssiveObjectKeys } from '../../../../../utils';
import { Checkbox } from '../../../../../components';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(0.9),
  whiteSpace: 'nowrap',
  fontSize: '13px'
}));

export const ArtificialManualOverrideOPDTable = ({
  data,
  columns,
  onRowClick,
  containerSX,
  selectedSearchCheak,
  fetchMoreDataSearch,
  sx,
  size,
  showInputField,
  handleInputChange,
  issLoading,
  fetchMoreData,
  selectedDepartment,
  input,
  pagination,
  showOk,
  isSelected,
  handleRowSelect,
  selectedRows
}) => {
  const [currentData, setCurrentData] = useState(data || []); // Holds current data
  const [itemCount, setItemCount] = useState(data.length); // Tracks the count of items displayed

  // Handles infinite scroll to fetch more data
  const onScroll = useCallback(
    (e) => {
      const scrollHeight = e.target.scrollHeight; // Total scroll height
      const scrollTop = e.target.scrollTop; // Distance from the top
      const clientHeight = e.target.clientHeight; // Visible height of the container

      // Check if we're near the bottom of the container
      const nearBottom = scrollHeight - scrollTop <= 550; // 100px from the bottom
      console.log(pagination.totalCount);
      if (!issLoading) {
        if (nearBottom && !issLoading && !(pagination.totalCount === 0)) {
          if (selectedSearchCheak) {
            
            fetchMoreDataSearch(pagination.currentPage + 1, selectedDepartment, input);
          } else {
            fetchMoreData(pagination.currentPage + 1, selectedDepartment);
          }
        }
      }
    },
    [
      issLoading,
      pagination.currentPage,
      pagination.totalCount,
      pagination.totalPages,
      selectedDepartment,
      fetchMoreData,
      fetchMoreDataSearch,
      selectedSearchCheak,
      input
    ]
  );

  // Update data whenever the parent provides new data
  useEffect(() => {
    setCurrentData(data); // Keep currentData updated with new data from parent
    setItemCount(data.length);
  }, [data]);



  return (
    <TableContainer sx={{ maxHeight: '259px', overflowY: 'auto', ...containerSX }} onScroll={onScroll}>
      <MuiTable sx={sx}>
        <TableHead>
          <TableRow sx={{ backgroundColor: 'lightblue' }}>
            {showOk && (
              <StyledTableCell key="ok-cell" sx={{ fontWeight: 'bold' }}>
                Edit
              </StyledTableCell>
            )}
            <StyledTableCell key="sr.no.-cell" sx={{ fontWeight: 'bold' }}>
              Sr. No.
            </StyledTableCell>
            {columns.map((column, index) => (
              <StyledTableCell sx={{ fontWeight: 'bold' }} key={`header-cell-${index}`}>
                {column.header}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {currentData.map((row, rowIndex) => (
            <TableRow
              {...(onRowClick && {
                onClick: () => {
                  onRowClick(row);
                }
              })}
              sx={{
                backgroundColor: rowIndex % 2 ? 'grey.200' : 'none',
                cursor: onRowClick ? 'pointer' : 'default',
                '&:hover': {
                  backgroundColor: 'grey.300'
                },
                transition: 'all 0.1s ease-in',
                backgroundColor: isSelected(row, 'ok') ? 'lightgreen' : 'none',
                '&:hover': { backgroundColor: 'grey.300' }
              }}
              key={row._id}
            >
              {showOk && (
                <StyledTableCell>
                  <Checkbox
                    sx={{
                      transform: 'scale(0.8)',
                      padding: '0'
                    }}
                    name={row?._id}
                    disabled={false}
                    checked={isSelected(row, 'ok')}
                    onChange={() => handleRowSelect(row, 'ok')}
                  />
                </StyledTableCell>
              )}
              <StyledTableCell key={`${row._id}-cell0`}>{rowIndex + 1}</StyledTableCell>
              {columns.map(({ header, accessor, sx }, colIndex) => (
                <StyledTableCell sx={sx} key={`${row._id}-cell${colIndex + 1}`}>
                  {header === 'OPD Charge' && showInputField ? (
                    <TextField
                      name="opd_charge"
                      value={row.inputValues[0]?.[header] || ''}
                      onChange={(e) => handleInputChange(e, row._id, header)}
                      disabled={!selectedRows.some((selectedRow) => selectedRow._id === row._id)}
                      variant="outlined"
                      size="small"
                      sx={{
                        width: '60px',
                        '& .MuiOutlinedInput-input': {
                          padding: '4px 8px'
                        },
                        '& .MuiInputBase-root': {
                          padding: '0px'
                        }
                      }}
                    />
                  ):header === 'No. Of Patient' && showInputField ? (
                                      <TextField
                                        value={row.inputValues[0]?.[header] || ''}
                                        onChange={(e) => handleInputChange(e, row._id, header)}
                                        disabled={!selectedRows.some((selectedRow) => selectedRow._id === row._id)}
                                        variant="outlined"
                                        name="ipd_charge"
                                        size="small"
                                        type="number"
                                        sx={{
                                          width: '60px',
                                          '& .MuiOutlinedInput-input': {
                                            padding: '4px 8px'
                                          },
                                          '& .MuiInputBase-root': {
                                            padding: '0px'
                                          }
                                        }}
                                      />
                                    ) : typeof accessor === 'function' ? (
                    accessor(row) || '-'
                  ) : (
                    <>
                      {header === 'Created At' || header === 'Date'
                        ? dateFormatter(getReccurssiveObjectKeys(row, accessor)) || '-'
                        : getReccurssiveObjectKeys(row, accessor) || '-'}
                    </>
                  )}
                </StyledTableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
};
